import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { userScopedStorage } from '../Search/userScopedStorage';

const STORAGE_KEY = 'firmable.teammate-onboarding';

/**
 * Onboarding-flow flags only. `onboardingDone` persists (per Clerk user, in localStorage): once the
 * user skips, saves or personalises from the home ICP card, home shows the search from then on.
 * The ICP itself — text fields and who-you-sell-to — is backend-owned (GET/PATCH /customer/icp).
 */
export interface TeammateProfileState {
  onboardingDone: boolean;
  // Edit / Set up from the ICP strip: reopens the card without touching the persisted flag.
  editing: boolean;
  markDone: () => void;
  clearProfile: () => void;
  resetOnboarding: () => void;
}

export const useTeammateProfile = create<TeammateProfileState>()(
  persist(
    (set) => ({
      onboardingDone: false,
      editing: false,
      markDone: () => set({ onboardingDone: true, editing: false }),
      clearProfile: () => set({ onboardingDone: false, editing: false }),
      resetOnboarding: () => set({ editing: true }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => userScopedStorage),
      version: 1,
      partialize: (state) => ({ onboardingDone: state.onboardingDone }),
    },
  ),
);
